import { InjectionToken } from '@angular/core';

export interface IAuthenticationDataService {
    getUserId(): string | null;
}

export const AUTH_DATA_SERVICE_TOKEN = new InjectionToken<IAuthenticationDataService>('IAuthenticationDataService');